import { useState, forwardRef, useEffect } from "react";
import { TabView, TabPanel, InputTextarea, Button, InputText } from "primereact";
import { getCommonParam, languageSupported } from "../config";

const MultiLanguageEditor = ({
  label,
  type = "input-text",
  languages,
  content,
  className,
  isReadOnly = false,
  setValue,
  fieldName,
  isAddItem = false,
  error,
}) => {
  const getLngVal = () => {
    if (!content) return "";
    const initVal = content.map((item) => ({ lingua: item.lingua, testo: item.testo }));
    return initVal.reduce((obj, item) => {
      obj[item.lingua] = isAddItem ? null : item.testo;
      return obj;
    }, {});
  };

  const [text, setText] = useState(undefined);
  const { companyId } = getCommonParam();

  const handleOnChange = (e, lng) => {
    const value = e.target.value;
    const newValue = { ...text, [lng]: value };
    setText(newValue);
    const val = content.find((item) => item.lingua === lng);
    setValue(fieldName, [
      { ...val, testo: value, idazienda: companyId },
      ...content.filter((item) => item.lingua !== lng),
    ]);
  };

  useEffect(() => {
    if (!isAddItem) {
      const init = getLngVal();
      setText(init);
    }
  }, [content]);

  const getTab = (key) => {
    const language = languageSupported.find((lng) => lng.key === key);
    return (
      <div className="field mb-1 col-12 md:col-12">
        <label htmlFor={`label-${language.key}`} className="font-medium text-600">
          <img src="images/flag_placeholder.png" className={`flag ${language.icon}`} />
          <span className="px-2">{language.language}</span>
          {text && text[key] ? (
            <i className="pi pi-check" style={{ color: "green", fontWeight: "bold", fontSize: "1.2rem" }}></i>
          ) : (
            <i className="pi pi-info-circle" style={{ color: "red", fontWeight: "bold", fontSize: "1.2rem" }}></i>
          )}
        </label>
      </div>
    );
  };

  return (
    <div className={`w-full flex flex-column gap-2 ${className}`}>
      <div className="card">
        {label && <label className="font-medium text-600">{label}</label>}
        <TabView>
          {languages &&
            languages.split(",").map((lng, index) => (
              <TabPanel header={getTab(lng)} key={`lng-${index}`}>
                <div className="w-full h-full">
                  {type === "input-text" ? (
                    <InputText
                      className="w-full"
                      value={(text && text[lng]) || ""}
                      onChange={(e) => handleOnChange(e, lng)}
                      type="text"
                      readOnly={isReadOnly}
                    />
                  ) : (
                    <InputTextarea
                      rows={5}
                      className="w-full h-19rem  "
                      autoResize
                      value={(text && text[lng]) || ""}
                      onChange={(e) => handleOnChange(e, lng)}
                      readOnly={isReadOnly}
                    />
                  )}
                  {error && <span className="text-xs font-bold text-red-500 ">{error.message || error}</span>}
                </div>
              </TabPanel>
            ))}
        </TabView>
      </div>
    </div>
  );
};

export default MultiLanguageEditor;
